import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import { useTranslation } from 'react-i18next'

import AnalyticsCard from '../AnalyticsCard/AnalyticsCard'

/**
 * @param {{
 *   setDateFilter?: (dates: [Date | null, Date | null]) => void,
 *   dateFilter?: [Date | null, Date | null] | Date[],
 *   analytics: object,
 *   mapping?: object[],
 * }} props
 */
const AnalyticsItem = ({ setDateFilter = () => {}, dateFilter = [], analytics, mapping = [] }) => {
  const { t } = useTranslation(['rewards-dashboard'])
  const [startDate, endDate] = dateFilter

  return (
    <div className="rewards-dashboard-item">
      <div className="rewards-dashboard-item__actions">
        <span className="rewards-dashboard-item__actions__title">
          {t('rewards-dashboard:analyticsItem.title')}
        </span>
        <div className="rewards-dashboard-item__actions__time-range">
          <span>{t('rewards-dashboard:analyticsItem.dataReportsLabel')}</span>
          <DatePicker
            className={'input borderless'}
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            maxDate={new Date()}
            placeholderText={t('rewards-dashboard:leaderBoard.selectDateRangePlaceholder')}
            isClearable={true}
            onChange={setDateFilter}
          />
        </div>
      </div>
      <div className="rewards-dashboard-item__cards">
        {mapping.map((card) => (
          <AnalyticsCard
            key={card.name}
            icon={card.icon}
            text={card.text}
            value={
              card.isValue && !isNaN(analytics[card.name])
                ? `$ ${analytics[card.name]}`
                : analytics[card.name]
            }
          />
        ))}
      </div>
    </div>
  )
}

AnalyticsItem.propTypes = {
  setDateFilter: PropTypes.func,
  dateFilter: PropTypes.array,
  mapping: PropTypes.array,
  analytics: PropTypes.object,
}

export default AnalyticsItem
